import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { shopify } from "@/lib/platforms-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/platformy/shopify";

export const Route = createFileRoute("/platformy/shopify")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia Shopify — integracje, migracje, Shopify Plus | SyncTech",
      description:
        "Wdrożenia i migracje Shopify oraz Shopify Plus. Integracje z Baselinker, Allegro, kurierzy, ERP. Aplikacje custom, headless commerce, optymalizacja konwersji. Bezpłatna wycena.",
      path: PATH,
    }),
  component: () => <PlatformPage data={shopify} path={PATH} breadcrumbCategory="Platformy" />,
});
